// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// Verion : 0.0.2
// LastEdit : AGALYA
// Last ADD : ADDED COMMENTS
// MODFIED DATA : 28-02-2026

const ACCURED_INTERESTReportTypes = {
	/** ***************** FETCH AccuredInterest DETAILS START *********************** */
	FETCH_ACCURED_INTEREST_REPORT_START: 'fetch_Accured_Interest_ReportStart',
	FETCH_ACCURED_INTEREST_REPORT_SUCCESS: 'fetch_Accured_Interest_ReportSuccess',
	FETCH_ACCURED_INTEREST_REPORT_FAILURE: 'fetch_Accured_Interest_ReportFailure',
	FETCH_ACCURED_INTEREST_REPORT_RESPONSE_RESET_START:
		'fetch_Accured_Interest_ReportResponseResetStart',
	FETCH_ACCURED_INTEREST_REPORT_RESPONSE_CHANGED:
		'fetch_Accured_Interest_ReportResponseResetChanged',
	/** ***************** FETCH AccuredInterest DETAILS END *********************** */
};
export default ACCURED_INTERESTReportTypes;
